<script>
    import LinearProgress from "@smui/linear-progress";
    import { navigate, Link } from "svelte-routing";
    import List, {
        Group,
        Item,
        Graphic,
        Meta,
        Label,
        Separator,
        Subheader,
        Text,
        PrimaryText,
        SecondaryText,
    } from "@smui/list";

    import { onMount } from "svelte";
    import { post } from "../../http";
    import { setObject } from "../../session";
    import title from "../../components/title";

    export let location;

    let loading = true;
    let data;

    function loadList() {
        loading = true;
        post("/api/address_list")
            .then((resp) => {
                if (resp.status == 0) {
                    if (resp.data == null || resp.data.length == 0)
                        navigate("/shipper/contact");
                    else data = resp.data;
                } else navigate("/server-error");
            })
            .finally(() => (loading = false));
    }

    function next(address) {
        const order = {
            origin_code: address.origin_code,
            shipper_name: address.customer_name,
            shipper_phone: address.customer_phone,
            shipper_address: address.address,
            shipper_province: address.province,
            shipper_city: address.city,
            shipper_district: address.district,
            shipper_zipcode: address.zipcode,
        };
        setObject("order", order);
        navigate("/destination/contact");
    }

    onMount(() => {
        loadList();
        sessionStorage.removeItem("shipper");
        title.set("Pilih alamat");
    });
</script>

<style lang="scss">
    :global(.mdc-list.address .mdc-list-item) {
        border-bottom: 1px solid #ccc;
        &:first-child {
            border-top: 1px solid #ccc;
        }
    }
    .content > div:first-child {
        margin-top: 16px;
    }
</style>

<div class="loading">
    {#if loading}
        <LinearProgress indeterminate />
    {/if}
</div>
<div class="content nopadding">
    {#if data != null && data.length > 0}
        <div class="caption">Darimana paket akan dikirimkan?</div>
        <List class="address" threeLine>
            {#each data as item}
                <Item on:SMUI:action={() => next(item)}>
                    <Text>
                        <PrimaryText>{item.address_name}</PrimaryText>
                        <SecondaryText>{item.customer_name}</SecondaryText>
                        <SecondaryText>{item.address}</SecondaryText>
                    </Text>
                </Item>
            {/each}
        </List>
        <div class="caption">
            Atau tambahkan
            <Link to="/shipper/contact">alamat baru</Link>
        </div>
    {/if}
</div>
